import Axios from "axios";

export const csvDownloadHelper = {

    data() {
        return {
            Json2csvParser: require('json2csv').Parser
        }
    },
    created() {
    },
    methods: {
        downloadCsv(filename, fields, downloadValues) {

            var start = Date.now();

            console.log('starting to parse the order ', start)

            const json2csvParser = new this.Json2csvParser({fields});
            const csvConverted = json2csvParser.parse(downloadValues);

            console.log('finished to parse the order ', Date.now() - start)

            // console.log(csvConverted)

            // let link = document.createElement("a");

            //
            // var url = URL.createObjectURL(blob);
            // link.setAttribute("href", url);
            // link.setAttribute("download", filename);


            const blob = new Blob([csvConverted], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                const link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
            //
            // link.href = 'data:text/csv;charset=utf-8,' + csvConverted;
            // link.style = "visibility:hidden";
            // link.download = filename
            //
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
        },
        downloadLink(event, downloadLink) {
            console.log('download the links')
            const link = document.createElement('a');
            link.href = downloadLink;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            event.stopPropagation();

        }
    }
}